import React, { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { resetPassword } from "../../services/authService";
import "../welcome/welcome.scss";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const result = await resetPassword(token, password);
      setDone(true);
      setStatus(result.message || "Password updated. You can sign in now.");
    } catch (err) {
      setError(err.response?.data?.message || "This reset link is invalid or has expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-welcome-container">
      <div className="background-elements">
        <div className="bg-element bg-element-1"></div>
        <div className="bg-element bg-element-2"></div>
        <div className="bg-element bg-element-3"></div>
      </div>
      <div className="main-content">
        <div className="content-wrapper">
          <div className="welcome-card">
            <div className="card-background"></div>
            <div className="card-header">
              <h1 className="card-title">Choose a new password</h1>
              <p className="card-subtitle">Use at least 8 characters.</p>
            </div>
            <div className="card-content">
              {!token && (
                <p style={{ color: "#fca5a5", textAlign: "center" }}>This reset link is missing a token.</p>
              )}
              {token && !done && (
                <form onSubmit={handleSubmit} style={{ marginBottom: "1.5rem" }}>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="New password"
                    disabled={loading}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      background: "rgba(255, 255, 255, 0.08)",
                      color: "white",
                      marginBottom: "0.75rem",
                    }}
                  />
                  <input
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    placeholder="Confirm password"
                    disabled={loading}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      background: "rgba(255, 255, 255, 0.08)",
                      color: "white",
                      marginBottom: "0.75rem",
                    }}
                  />
                  <button type="submit" disabled={loading} className="google-signin-btn" style={{ marginBottom: 0 }}>
                    <div className="btn-background"></div>
                    <div className="btn-content">{loading ? "Saving..." : "Update password"}</div>
                  </button>
                </form>
              )}
              {error && (
                <p style={{ color: "#fca5a5", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {error}
                </p>
              )}
              {status && (
                <p style={{ color: "#86efac", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {status}
                </p>
              )}
              <div style={{ textAlign: "center" }}>
                <Link to="/" style={{ color: "#e879f9", textDecoration: "none", fontSize: "0.875rem", marginRight: "1rem" }}>
                  Playtester sign in
                </Link>
                <Link to="/developer/signin" style={{ color: "#e879f9", textDecoration: "none", fontSize: "0.875rem" }}>
                  Developer sign in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
